
import React, { useEffect, useState } from 'react';

import axios from 'axios';

import DataContext from './context';
import { DataValue, FeatureLogicDataType, TopThemeDataType, RaceEthnicityType, ReportDataType } from './types';

// const DEBUG = true;

const DataProvider = (props): JSX.Element => {
  // Data fetched from DB
  const [featureData, setFeatureData] = useState();
  const [featureLogicData, setFeatureLogicData] = useState();
  const [reportData, setReportData] = useState<ReportDataType>();
  const [themeData, setThemeData] = useState();
  
  // Data transformed by front-end
  const [topFeatureLogics, setTopFeatureLogics] = useState<FeatureLogicDataType[]>([]);
  const [topRaceEthnicities, setTopRaceEthnicities] = useState<RaceEthnicityType[]>([]);
  const [topThemes, setTopThemes] = useState<TopThemeDataType[]>([]);

  useEffect(() => {
    fetchWithKeyAndCallback('/data_features/', {}, 'features', setFeatureData);
    fetchWithKeyAndCallback('/data_themes/', {}, 'themes', setThemeData);
  }, []);

  function fetchWithKeyAndCallback (url: string, data: any, key: string, callback: (data: any) => void) {
    axios
      .get(url, data)
      .then((res) => {
        const data = res.data;
        if (data.status === 'OK') {
          callback(data[key]);
        }
      })
      .catch((err) => {
        callback(null);
        console.error(err);
      });
  }

  function fetchFeatureLogicDataByIds (ids: any[]) {
    axios
    .post('/data_feature_logics_by_ids/', { ids: ids })
    .then((res) => {
      if (res.data.status === 'OK') {
        setFeatureLogicData(res.data.featureLogics);
      }
    })
    .catch((err) => {
      setFeatureLogicData(null);
      console.error(err);
    });
  }

  const value: DataValue = {
    featureData,
    featureLogicData,
    reportData,
    themeData,
    fetchFeatureLogicDataByIds,
    topFeatureLogics,
    topRaceEthnicities,
    topThemes,
    setReportData,
    setTopFeatureLogics,
    setTopRaceEthnicities,
    setTopThemes,
  };

  return <DataContext.Provider value={value} {...props} />;
};

export default DataProvider;
